<template>
  <div class="container commonDetail">
    <el-breadcrumb separator="/">
      <el-breadcrumb-item :to="{ path: '/Mine/MyRegister' }"
        >登记列表</el-breadcrumb-item
      >
      <el-breadcrumb-item>登记详情</el-breadcrumb-item>
    </el-breadcrumb>
    <div class="commonWhiteBg" v-if="orderInfo">
      <div class="topSteps">
        <el-steps :active="orderInfo.step">
          <el-step title="支付">
            <div slot="description">
              {{
                orderInfo.status == "10" ? "等待支付" : paymentInfo.payTimeText
              }}
            </div>
            <a-icon v-if="orderInfo.status != '10'" slot="icon" type="check" />
            <a-icon v-else slot="icon" type="redo" />
          </el-step>
          <el-step title="登记审核">
            <template v-if="orderInfo.status == '11'">
              <div slot="description">审核预计需要一周时间</div>
              <a-icon slot="icon" type="exclamation" />
            </template>
            <template v-else-if="orderInfo.status == '12'">
              <div slot="description">审核中，请稍后</div>
              <a-icon slot="icon" type="redo" />
            </template>
            <template v-else>
              <!-- <div slot="description">2020.12.29 12:10:54</div> -->
              <a-icon slot="icon" type="check" />
            </template>
          </el-step>
          <el-step title="登记证书">
          
            <template v-if="orderInfo.status == '14'">
              <div slot="description">获得登记证书</div>
              <a-icon slot="icon" type="redo" />
            </template>
            <template v-else-if="orderInfo.status == '21'">
              <div slot="description">{{orderInfo.updateTimeText}}</div>
              <a-icon slot="icon" type="check" />
            </template>
              <template v-else>
              <div slot="description">获得登记证书</div>
              <a-icon slot="icon" type="exclamation" />
            </template>
          </el-step>
        </el-steps>
        <div class="rightMain">
          <div>
            <span class="label"> 订单编号：</span>
            <span class="value"> {{ orderInfo.orderNo }} </span>
          </div>
          <div>
            <span class="label"> 支付方式：</span>
            <span class="value"> {{ orderInfo.orderAmount }}</span>
          </div>
          <div class="btnWrap" v-if="orderInfo.status == '10'">
            <el-button type="primary" size="mini" @click="onGoPay">立即支付</el-button>
          </div>
        </div>
      </div>

      <div class="pdfShow" v-if="orderInfo.status == '21'">
        <div>
          <div class="commonTitle">登记证书</div>
          <p class="tittle">温馨提示：</p>
          <p class="desc">
            1、使用中国知链微信小程序，扫描二维码可查验证书真伪；<br />
            2、通过中国知链防伪查询网址可查验真伪。<br />
          </p>
          <div class="btnWrap">
            <el-button type="primary" size="mini">下载存证证书</el-button>
          </div>
        </div>
        <div>
          <img
            src="https://ipchain.oss-cn-hangzhou.aliyuncs.com/web/useless/zhenshu.png"
            class="img"
          />
        </div>
      </div>

      <div class="commonTitle mt32">登记信息</div>
      <div>
        <el-form ref="form" label-width="140px">
          <el-form-item label="订单编号" prop="orderNo">
            {{ orderInfo.orderNo }}
          </el-form-item>
          <el-form-item label="支付方式" prop="paymodeText">
            {{ orderInfo.paymodeText }}
          </el-form-item>
          <el-form-item label="存证文件" prop="evidenceFile">
            <div class="nameRow">
              <span v-for="(file, index) in orderInfo.items" :key="index"
                >{{ file.sourceName }} &nbsp;</span
              >
              <router-link
                :to="{ path: '/ExistingEvidence/FileList', query: { orderNo: orderNo,bizType:'register' } }"
              >
                查看存证文件
              </router-link>
            </div>
          </el-form-item>
          <el-form-item label="登记名称">
            {{ orderInfo.subject }}
          </el-form-item>
          <el-form-item label="权利权属" prop="ownership" class="ownershipRow">
            {{ constants.ownership[orderInfo.belong].label }}
          </el-form-item>
          <el-form-item label="作者" prop="author">
            <span v-for="(author,index) in orderInfo.authors" :key="index">{{obligees[author]}} &nbsp; </span>
          </el-form-item>
          <el-form-item label="著作权人" prop="right">
            <span v-for="(author,index) in orderInfo.obligee" :key="index">{{obligees[author]}} &nbsp; </span>
          </el-form-item>
          <el-form-item label="作品创作类型" prop="creationType">
            {{ constants.creationType[orderInfo.creationType].label }}
          </el-form-item>
          <el-form-item label="作品创作性质" prop="creationNature">
            {{ constants.creationNature[orderInfo.creationProperty].label }}
          </el-form-item>
          <el-form-item label="创作完成时间" prop="finishTime">
            {{ orderInfo.finishTimeText }}
          </el-form-item>
          <el-form-item label="创作完成地点" prop="adress">
            {{ orderInfo.completeLocation.province }} {{ orderInfo.completeLocation.city }}{{ orderInfo.completeLocation.area }}
          </el-form-item>
          <el-form-item label="作品发表状态" prop="publishStatus">
            {{ constants.publishStatus[orderInfo.publishStatus].label }}
          </el-form-item>
          <el-form-item label="权益拥有情况" prop="rightHave">
            <multiple-select
              v-model="orderInfo.copyrights"
              :isResultView="true"
              :listOpt="constants.right"
            ></multiple-select>
          </el-form-item>
          <el-form-item label="创作意图" prop="yitu">
            <el-input
              v-model="orderInfo.creationIntention.text"
              :rows="4"
              disabled
              placeholder="请输入创作意图"
              type="textarea"
            ></el-input>
          </el-form-item>
          <el-form-item label="作品独创性" prop="name" class="mt8">
            <el-input
              v-model="orderInfo.creationOriginality.text"
              :rows="4"
              disabled
              placeholder="请输入作品存证名称"
              type="textarea"
            ></el-input>
          </el-form-item>
        </el-form>
      </div>
    </div>
        <pay-dialog ref="payDialog" @close="onSetPayDialogClose"></pay-dialog>
  </div>
</template>

<script>
import {
  queryRegisterOrder,
  queryPaymentOrderByOutBizNp,
  paymentRegisterOrder
} from "@/api/EvidenceService";
import { queryObligeeList } from "@/api/ObligeeService";
import constants from "@/utils/constants";
import PayDialog from "@/views/multipleService/components/PayDialog";
import multipleSelect from "../../../components/form/multipleSelect";
export default {
  name: "RegisterDetail",
  components: { multipleSelect,PayDialog },
  data() {
    return {
      constants,
      orderNo: this.$route.query.orderNo,
      orderInfo: null,
      paymentInfo: {},
      stepIdx: 0, // 0 带支付, 1处理中,3 完成
      obligees: {},
    };
  },
  created() {
    this.loadData();
  },
  methods: {
      getStep(status){
      let step=0;
      if(status=='10'){
        step=0;
      }else if(status*1<21){
        step=1;
      }else {
        step=2;
      }
      return step;
    },
    loadData() {
      queryRegisterOrder(this.orderNo).then(({ data }) => {
        this.orderInfo = data;
        this.orderInfo.paymodeText = constants.paymode[this.orderInfo.paymode];
        this.orderInfo.finishTimeText = this.dayjs(
          this.orderInfo.completeTime * 1000
        ).format("YYYY-MM-DD");
          this.orderInfo.step=this.getStep(this.orderInfo.status);

        this.orderInfo.createTimeText = this.dayjs(
          this.orderInfo.createTime * 1000
        ).format("YYYY-MM-DD HH:mm:ss ");
        this.orderInfo.updateTimeText = this.dayjs(
          this.orderInfo.updateTime * 1000
        ).format("YYYY-MM-DD HH:mm:ss ");

        if (this.orderInfo.status != "10") {
          queryPaymentOrderByOutBizNp(this.orderNo, "2").then(({ data }) => {
            this.paymentInfo = data;
            if(this.paymentInfo.updateTime){
              this.paymentInfo.payTimeText = this.dayjs(
                this.paymentInfo.updateTime * 1000
              ).format("YYYY-MM-DD HH:mm:ss ");
            }else{
              this.paymentInfo.payTimeText = '';
            }
          });
        }
      });

      queryObligeeList(1, 100).then(({ data }) => {
        let obligees={};
        for (let i = 0; i < data.list.length; i++) {
          const element = data.list[i];
            obligees[element.obligeeCode]=element.obligeeType=='1'?element.userName:element.companyName;
        }
        this.obligees = obligees;
      });
    },
     onGoPay() {
      let that = this;
      paymentRegisterOrder(that.orderNo).then(({data})=>{
            that.$refs.payDialog.showDialog(data);
            that.isPayDialogVisible = true;
      })
    
    },
    onSetPayDialogClose(result) {
      console.log(result);
      if (result) {
        this.loadData();
      }
    },
  },
};
</script>

<style lang='scss' scoped>
@import "../../../assets/css/inputForm.scss";
</style>
